var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "link") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Individual-Entry-After-Vote-v1",
    transform: "translate(-822.000000, -1923.000000)",
    fill: "#B7844D",
    fillRule: "nonzero",
    stroke: "#B7844D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(823.000000, 1924.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37625283,16.3355019 C9.48333351,16.4411746 9.62833788,16.5 9.78004694,16.5 C9.93175599,16.5 10.0767604,16.4411718 10.183841,16.3355019 L14.6666667,11.9572721 L13.859107,11.1685549 L9.78433016,15.1535556 L1.3774973,6.94817455 L7.11416631,1.34535675 L10.2217904,4.38047204 L11.0293501,3.59175481 L7.51681822,0.163410406 C7.40973754,0.0588281924 7.26473317,0 7.11302411,0 C6.96131506,0 6.81631069,0.0588281924 6.70923,0.163410406 L0.167314278,6.55491754 C0.0602335968,6.65949975 0,6.80221124 0,6.95037775 C0,7.09854425 0.0602335968,7.24016809 0.167314278,7.3447503 L9.37625283,16.3355019 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12451555,11.0274833 L12.3492613,6.8441877 L20.6413105,15.0518137 L14.9829677,20.654641 L11.9177739,17.6195206 L11.1212403,18.4082391 L14.5858135,21.8365893 C14.6914321,21.9411717 14.8344567,22 14.9840943,22 C15.133732,22 15.2767566,21.9411717 15.3823752,21.8365893 L21.8349702,15.4450714 C21.9405888,15.340489 22,15.1977773 22,15.0496105 C22,14.9014438 21.9405888,14.7598197 21.8349702,14.6552373 L12.7517669,5.66449834 C12.6461482,5.5588255 12.5031237,5.5 12.353486,5.5 C12.2038483,5.5 12.0608238,5.55882829 11.9552051,5.66449834 L7.33333333,10.2376771 L8.12451555,11.0274833 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.884314fdef204f9372719a3cbd0a6249.svg";
export { ForwardRef as ReactComponent };